/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const FullScreenEnterLargeIcon = ({ width = 20, height = 20, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 20 20' fill={color} {...props} xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 1.3C0 0.58203 0.58203 0 1.3 0H6.5C6.77614 0 7 0.223858 7 0.5C7 0.776142 6.77614 1 6.5 1H1.3C1.13431 1 1 1.13431 1 1.3V6.5C1 6.77614 0.776142 7 0.5 7C0.223858 7 0 6.77614 0 6.5V1.3Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 18.7C0 19.418 0.58203 20 1.3 20H6.5C6.77614 20 7 19.7761 7 19.5C7 19.2239 6.77614 19 6.5 19H1.3C1.13431 19 1 18.8657 1 18.7V13.5C1 13.2239 0.776142 13 0.5 13C0.223858 13 0 13.2239 0 13.5V18.7Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 1.3C20 0.58203 19.418 0 18.7 0H13.5C13.2239 0 13 0.223858 13 0.5C13 0.776142 13.2239 1 13.5 1H18.7C18.8657 1 19 1.13431 19 1.3V6.5C19 6.77614 19.2239 7 19.5 7C19.7761 7 20 6.77614 20 6.5V1.3Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 18.7C20 19.418 19.418 20 18.7 20H13.5C13.2239 20 13 19.7761 13 19.5C13 19.2239 13.2239 19 13.5 19H18.7C18.8657 19 19 18.8657 19 18.7V13.5C19 13.2239 19.2239 13 19.5 13C19.7761 13 20 13.2239 20 13.5V18.7Z'
    />
  </svg>
);

export default FullScreenEnterLargeIcon;
